import React from "react";
import styled from "styled-components";
import HLine from "../../components/components/hline";
import { Heading } from "../../components/components/text";

const TheGameContainer = styled.div`
  color: #5a2800;
  h2 {
    margin-bottom: 0.3em;
  }
  p {
    margin-top: 0.3em;
  }
`;

export default function TheGame() {
  return (
    <TheGameContainer>
      <HLine />
      <Heading>The Game</Heading>
      <HLine />
      <h2>RPG</h2>
      <p>
        TibiaSwap is a Tibia Server based on Tibia 7.4 mechanics. The game has a
        genuine 7.X global map, with all the quests from that time. TibiaSwap's
        RPG goes even further than that - there was always a mystery around
        extremely rare items. People gathered around trying to solve mysteries,
        that were unsolvable until we came. Exploring is always worth your time
        here in TibiaSwap. There is no unobtainable item... but they wont come
        easy.
      </p>
      <h2>PVE</h2>
      <p>
        Player vs Environment is an important part of Tibia, be it for the
        economy or to advancement of your character. Every dungeon has its own
        mysteries and dangers to be explored. Here, on TibiaSwap we made sure
        that all the monsters are behaving correctly. Unlike any other server,
        we implemented true oldschool monster AI, which if properly stimulated,
        will be even more dangerous! Be it the attacks or the defences, which
        will be accurate only with our monsters inventories being filled with
        loot on spawn, which if properly equiped, will also affect their stats.
      </p>
      <h2>PVP</h2>
      <p>
        Player vs Player is also a big part of Tibia. Control dungeons, respawns
        or just gank other players, it is all part of a PVP gameplay. The staff
        will never intervene if you are not breaking any <a href="#">rules</a>.
      </p>
      <h2>The Economy</h2>
      <p>
        In addition to all the features that will attract players to the game,
        our Blockchain integration will take it even further. In TibiaSwap, the
        gold coins earned during your journey can be instantly sold and swapped
        to 💵 USDC (cryptocurrency which worth is bound to US dollar). You can
        use them to buy your premium time, change sex or send them straight to
        your Phantom wallet! This means that in addition to all the fun and
        mysteries you will be unraveled playing TibiaSwap, you actually earn
        money while playing! 💰 It's worth noting that our economy is very
        sustainable and will last for years to come!
      </p>
      <h2>NFT's</h2>
      <p>
        During your journey through TibiaSwap you will find a variety of NFTs.
        When obtaining an item, player can choose to keep it in-game or mint it,
        to store it on his wallet. TibiaSwap players will transfer items,
        outfits, and addons in and out of the game. Minting an NFT makes it
        yours to sell on various marketplaces, or to keep as a collectible!
      </p>
    </TheGameContainer>
  );
}
